<template>
    <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-800">
        <div class="w-full sm:max-w-md mt-6 px-6 py-4 bg-gray-100 shadow-md overflow-hidden sm:rounded-lg">
            <authentication-card-logo />
            <div class="flex justify-center">TERMINAL</div>

            <div class="text-center">
                <div>
                    {{ $t('Scan with POS to register terminal') }}
                </div>
                <div class="flex justify-center my-4">
                    <qrcode v-if="terminalId" class="mt-3 mx-auto" :value="terminalId" :options="{ width: 400 }" dusk="qr-code" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthenticationCardLogo from "../../Shared/Components/AuthenticationCardLogo.vue";

export default {
    name: 'TerminalLogin',
    components: {AuthenticationCardLogo},
    data() {
        return {
            terminalId: 'hash-1234',
        }
    },
    mounted() {
        const terminal = window.location.href.split('/').pop();
        window.localStorage.setItem('terminal', terminal);
    },
}
</script>
